import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import React from 'react';
import Step from 'apollo-react/components/Step';
import StepLabel from 'apollo-react/components/StepLabel';
import Stepper from 'apollo-react/components/Stepper';

import { pages } from '../../../../../Shared/constants';

export const Pagination = ({ steps, intl }) => (
  <Stepper activeStep={steps.index} alternativeLabel>
    <Step key={pages.step1.index}>
      <StepLabel>{intl.formatMessage({ id: 'journeyBuilder.configuration' })}</StepLabel>
    </Step>
    <Step key={pages.step2.index}>
      <StepLabel>{intl.formatMessage({ id: 'journeyBuilder.warning' })}</StepLabel>
    </Step>
  </Stepper>
);

export const mapStateToProps = state => {
  const { steps } = state.journeyBuilderConfigurationArea;

  return { steps };
};

Pagination.displayName = 'Pagination';

export default compose(
  connect(mapStateToProps),
  injectIntl
)(Pagination);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/Navigation/Pagination/index.js